import SVGIcons from './SVGIcon';
export type {SVGIconProps, SVGType} from './SVGIcon';
export default SVGIcons;
